import { render, staticRenderFns } from "./wallet-tabar.vue?vue&type=template&id=6335eca0&scoped=true&"
import script from "./wallet-tabar.vue?vue&type=script&lang=js&"
export * from "./wallet-tabar.vue?vue&type=script&lang=js&"
import style0 from "./wallet-tabar.vue?vue&type=style&index=0&id=6335eca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335eca0",
  null
  
)

export default component.exports